<template>
    <main v-if="isLoading" id="js-page-content" class="users-v2" role="main">
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('menu.companies.back_office') }}</div>
        </portal>

        <header class="users-hero">
            <h1 class="users-hero-title">{{ $t('menu.companies.back_office') }}</h1>
            <p class="users-hero-sub">{{ totalLabel }}</p>
        </header>

        <section class="users-card">
            <TabUsers v-if="users" @get-data="getData" />
        </section>
    </main>
</template>

<script>
import TabUsers from '@/components/Model/Company/TabUsers'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'Users',
    components: {
        TabUsers
    },
    data() {
        return {
            isLoading: false
        }
    },
    created() {
        this.getData()
    },
    computed: {
        ...mapState('company', {
            users: (state) => state.users
        }),
        totalLabel() {
            const n = Array.isArray(this.users)
                ? this.users.length
                : (this.users && this.users.total ? this.users.total : 0)
            const formatted = new Intl.NumberFormat(this.$i18n.locale).format(n)
            const key = n === 1 ? 'company.users.count_one' : 'company.users.count_other'
            return this.$t(key, { count: formatted })
        }
    },
    methods: {
        ...mapActions('company', ['getUsers']),
        getData() {
            this.getUsers()
                .then(() => {
                    this.isLoading = true
                })
                .catch((e) => {
                    this.$store.dispatch('dispatchError', e)
                })
        }
    }
}
</script>

<style scoped>
.users-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.users-hero {
    margin-bottom: var(--v2-space-5);
}

.users-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.users-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.users-card {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
}

@media (max-width: 900px) {
    .users-v2 {
        padding: 16px 18px 32px;
    }

    .users-hero-title {
        font-size: 1.375rem;
    }
}
</style>
